<template lang="pug">
  #socioec
    Header
    v-container.pl-0()
      v-col(xs=12 sm=12)
        v-row.py-1
          .form-title.main.light Datos Socioeconómicos
        v-row.py-1
          h1.form-title2.accent-text Datos de la Víctima
        v-row.py-1
          v-col(d-flex xs=12 sm=2)
            v-menu(
              v-model="registryDatePickerMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            )
              template(
                v-slot:activator="{ on }"
              )
                v-text-field(
                  :value="formatDate(registryDate)"
                  label="Fecha de registro"
                  readonly
                  v-on="on"
                )
              v-date-picker(v-model="registryDate" @input="registryDatePickerMenu = false" color="grey lighten-2")

          v-col(d-flex xs=12 sm=4)
            label.custom.mb-2 Estado Cívil del familiar desaparecido
            v-radio-group(
              v-model="disappearedPersonStatus"
              row
            )
              v-radio(
                v-for="(personStatuse, i) in personStatuses"
                :key="personStatuse.slug"
                :label="personStatuse.name"
                :value="i"
              )


          v-col(d-flex xs=12 sm=3 v-if="showDisappearedPersonPartnerName")
            v-text-field(
            	v-model="disappearedPersonPartnerName"
            	label="Nombre del o de la cónyuge del familiar"
            )

          v-col(d-flex xs=12 sm=3 v-if="showDisappearedPersonPartnerName")
            v-menu(
              v-model="partnerDatePickerMenu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="290px"
              max-width="290px"
            )
              template(
                v-slot:activator="{ on }"
              )
                v-text-field(
                  :value="formatDate(disappearedPersonPartnerBirthday)"
                  label="Fecha de nacimiento de cónyuge"
                  readonly
                  v-on="on"
                )
              v-date-picker(v-model="disappearedPersonPartnerBirthday" @input="partnerDatePickerMenu = false" color="grey lighten-2")

        v-row.py-1.justify-space-between
          v-col(d-flex xs=12 sm=3)
            v-text-field(
            	v-model="disappearedPersonTelephone"
            	label="Teléfono de casa del familiar"
            )

          v-col(d-flex xs=12 sm=3)
            v-text-field(
            	v-model="disappearedPersonCellphone"
            	label="Teléfono celular del familiar"
            )

          v-col(d-flex xs=12 sm=2 v-if="showDisappearedPersonHasWhatsApp")
            label.custom.mb-2 ¿Tiene WhatsApp?
            v-radio-group(
            	v-model="disappearedPersonHasWhatsApp"
              row
            )
              v-radio(
              	v-for="(directAnswer, i) in directAnswers"
              	:key="directAnswer.slug"
              	:value="i"
              	:label="directAnswer.name"
              )

          v-col(d-flex xs=12 sm=4)
            v-text-field(
            	label="Correo electrónico del familiar"
            	v-model="disappearedPersonEmail"
            )
        v-row.py-1
          v-col(d-flex xs=12 sm=6)
            label.custom.mb-2 ¿Su familiar cuenta con bienes inmuebles?
            v-radio-group(
            	v-model="disappearedPersonHasProperties"
              row
            )
              v-radio(
                v-for="(directAnswer, i) in directAnswers"
                :key="directAnswer.slug"
                :value="i"
                :label="directAnswer.name"
              )
        v-row.py-1(v-for="(property, index) in propertyList" :key="index")
          v-col(d-flex xs=12 sm=3)
            v-text-field(
              v-model="propertyList[index].propertyName"
              label="Descripción"
              v-on:input="setterPropertyName(index, propertyList[index].propertyName)"
            )

          v-col(d-flex xs=12 sm=4)
            label.custom.mb-2 ¿Tipo de bien inmueble?
            v-radio-group(
              v-model="propertyList[index].propertyType"
              row
            )
              v-radio(
                v-for="(livingPlaceKind, i) in livingPlaceKinds"
                :key="livingPlaceKind.slug"
                :value="i"
              	:label="livingPlaceKind.name"
              	v-on:change="setterPropertyType(index, i)"
              )

        v-row.d-flex(v-if="showAddProperty")
          v-btn.add-dependent(
            fab
            v-on:click="addProperty"
          )
            v-icon add
          p.add-text Agregar bien inmueble

        v-row.py-1
          v-col(d-flex xs=12 sm=4)
            label.custom.mb-2 ¿Cuenta con servicio médico?
            v-radio-group(
            	v-model="disappearedPersonHasMedicalService"
              row
            )
              v-radio(
              	v-for="(directAnswer, i) in directAnswers"
              	:key="directAnswer.slug"
              	:value="i"
              	:label="directAnswer.name"
              )
        v-row.py-1.justify-space-between(v-if="showDisappearedPersonMedicalServiceProvider")
          v-col(d-flex xs=12 sm=6)
            label.custom.mb-2 ¿Con cuál?
            v-radio-group(
            	v-model="disappearedPersonMedicalServiceProvider"
              row
            )
              v-radio(
              	:label="medicalServiceProvider.name"
              	v-for="(medicalServiceProvider, i) in medicalServiceProviders"
              	:key="medicalServiceProvider.slug"
              	:value="i"
              )

          v-col(d-flex xs=12 sm=2)
            v-text-field(
            	label="Especificar"
            	v-model="disappearedPersonOtherMedicalService"
              :disabled = "!showDisappearedPersonOtherMedicalService"
            )

          v-col(d-flex xs=12 sm=4)
            v-text-field(
            	v-model="disappearedPersonMedicalServiceNumber"
            	label="Número de servicio médico"
            )

        v-row.py-1.justify-space-between
          v-col(d-flex xs=12 sm=3)
            label.custom.mb-2 ¿Su familiar cuenta con algún crédito?
            v-radio-group(
              v-model="disappearedPersonHasCredit"
              row
            )
              v-radio(
                v-for="(directAnswer, i) in directAnswers"
                :key="directAnswer.slug"
                :value="i"
                :label="directAnswer.name"
              )

        v-row.py-1(v-for="(credit, index) in creditList" :key="index")
          v-col(d-flex xs=12 sm=3)
            v-text-field(
              v-model="creditList[index].creditType"
              label="Tipo de crédito"
              v-on:input="setterCreditType(index, creditList[index].creditType)"
            )

          v-col(d-flex xs=12 sm=3)
            label.custom.mb-2 ¿Es un crédito mancomunado?
            v-radio-group(
            	v-model="creditList[index].isJoint"
              row
            )
              v-radio(
              	v-for="(directAnswer, i) in directAnswers"
              	:key="directAnswer.slug"
              	:value="i"
              	:label="directAnswer.name"
                v-on:change="setterJointCredit(index, i)"
              )

          v-col(d-flex xs=12 sm=4)
            v-text-field(
              v-if="creditList[index].isJoint == '0'"
              v-model="creditList[index].coaccreditedName"
              label="Nombre del coacreditado"
              v-on:input="setterCoaccreditedName(index, creditList[index].coaccreditedName)"
            )

        v-row.d-flex(v-if="showAddCreditButton")
          v-btn.add-dependent(
            fab
            v-on:click="addCredit"
          )
            v-icon add
          p.add-text Agregar crédito

        v-row.py-1.justify-space-between
          v-col(d-flex xs=12 sm=12)
            v-row
              label.custom.mb-2 ¿Su familiar es titular de algún tipo de seguro de vida, fondo de ahorro, fondo de inversión o pensión?
            v-row
              v-col(d-flex xs=12 sm=6)
                v-radio-group(
            	    v-model="disappearedPersonHasInsurance"
                  row
                )
                  v-radio(
              	    v-for="(directAnswer, i) in directAnswers"
              	    :key="directAnswer.slug"
              	    :value="i"
              	    :label="directAnswer.name"
                  )

              v-row.py-1(v-for="(insurance, index) in insuranceList" :key="index")
                v-col(d-flex xs=12 sm=4)
                  v-text-field(
                    v-model="insuranceList[index].insuranceName"
                    label="Nombre de seguro de inversión"
                    v-on:input="setterInsuranceName(index, insuranceList[index].insuranceName)"
                  )

                v-col(d-flex xs=12 sm=8)
                  label.custom.mb-2 ¿Tipo de seguro de inversión?
                  v-radio-group(
                    v-model="insuranceList[index].insuranceType"
                    row
                  )
                    v-radio(
                      v-for="(insuranceType, i) in insuranceTypes"
                      :key="insuranceType.slug"
                      :value="i"
                      :label="insuranceType.name"
                      v-on:change="setterInsuranceType(index, i)"
                    )

            v-row.d-flex(v-if="showAddInsurance")
              v-btn.add-dependent(
                fab
                v-on:click="addInsurance"
              )
                v-icon add
              p.add-text Agregar seguro, fondo o pensión

        v-row.py-1
          h1.form-title2.accent-text Condición de la Víctima

        v-row.py-1
          v-col(d-flex xs=6 sm=6)
            v-row
              v-col.px-0(d-flex xs=12 sm=8)
                v-row
                  label.custom.mb-2 ¿El familiar se encuentra registrado en la CEAV con calidad de víctima?
              v-col(d-flex xs=12 sm=4)
                v-radio-group(
                	v-model="disappearedPersonIsRegisteredCEAV"
                  row
                )
                  v-radio(
                  	v-for="(directAnswer, i) in directAnswers"
                  	:key="directAnswer.slug"
                  	:value="i"
                  	:label="directAnswer.name"
                  )
          v-col(d-flex xs=6 sm=6 v-if="showDisappearedPersonWhichRegistry")
            v-row
              v-col(d-flex xs=12 sm=5)
                v-row
                  label.custom.mb-2 ¿En qué registro se encuentra el familiar?
              v-col(d-flex xs=12 sm=6)
                v-radio-group(
                	v-model="disappearedPersonWhichRegistry"
                  row
                )
                  v-radio(
                  	:label="missingRegistrie.name"
                  	v-for="(missingRegistrie, i) in missingRegistries"
                  	:key="missingRegistrie.slug"
                  	:value="i"
                  )

        v-row.py-1
          h1.form-title2.accent-text Hijos y Dependientes Económicos

        v-row.py-1(v-for="index in economicDependents" :key="index")
          EconomicDependent(v-bind:economicDependentIndex="index -1")

        v-col.btn-h( xs=6 sm=6)
        v-row.d-flex
          v-btn.add-dependent(fab v-on:click="addEconomicDependent")
            v-icon add
          p.add-text Agregar hijo/a o dependiente económico

        v-row.py-1.justify-end
          v-btn.main-background.bold.mr-4.go-to(to="/") Cancelar
          v-btn.main-background.bold(v-on:click="updateReport") Guardar


</template>

<script>
import axios from "axios";
import Header from "@/components/Header.vue";
import Side from "@/components/Side.vue";
import EconomicDependent from "@/components/Socioeconomic/EconomicDependent.vue";

export default {
  name: "SocioecForm",
  props: {},
  components: {
    Header,
    Side,
    EconomicDependent
  },
  data(){
    return {
      registryDatePickerMenu: false,
      partnerDatePickerMenu: false,
      //Catalogs
      personStatuses : [{'name': 'Soltero/a', 'slug': 'single'},{'name': 'Casado/a', 'slug': 'married'},{'name': 'Concubino/a', 'slug': 'concubine'},{'name': 'Unión Libre', 'slug': 'freeUnion'},{'name': 'Viudo/a', 'slug': 'widower'}],
      livingPlaceKinds : [{'name':'Casa', 'slug':'home'},{'name':'Departamento', 'slug':'department'},{'name':'Terreno', 'slug':'land'}],
      insuranceTypes: [{'name':'Seguro de vida', 'slug':'lifeInsurance'},{'name':'Fondo de ahorro', 'slug':'savingFund'},{'name':'Fondo de inversión', 'slug':'investmentFund'},{'name':'Pensión', 'slug':'pension'},{'name':'Otro', 'slug':'other'}],
      missingRegistries : [{'name':'REEVI', 'slug':'reevi'},{'name':'RENAVI', 'slug':'renavi'}],
      //Toggle flags
      showDisappearedPersonPartnerName: false,
      showDisappearedPersonHasWhatsApp: false,
      showDisappearedPersonMedicalServiceProvider: false,
      showDisappearedPersonOtherMedicalService: false,
      showAddProperty: false,
      showAddCreditButton: false,
      showAddInsurance: false,
      showDisappearedPersonMedicalServiceNumber: false,
      showDisappearedPersonWhichRegistry: false,
    };

  },
  watch:{
    /*
    disappearedPersonStatus : function(newVal, oldVal){
      // Setter at first is the index, must convert to object
      if(typeof newVal != "object"){
        newVal = this.personStatuses[newVal]
      }

      var variableRelationship = {
        flagVar: 'showDisappearedPersonPartnerName',
        relatedVar: '$store.state.record.socioec.disappearedPerson.partnerName',
        defaultValueRelatedVar: ''
      }

      var secondVariableRelationship = {
        flagVar: 'showDisappearedPersonPartnerName',
        relatedVar: '$store.state.record.socioec.disappearedPerson.partnerBirthday',
        defaultValueRelatedVar: null,
      }

      if(newVal && newVal.slug == 'married'){
        variableRelationship.conditionSuccess = true;
        secondVariableRelationship.conditionSuccess = true;
      }else{
        variableRelationship.conditionSuccess = false;
        secondVariableRelationship.conditionSuccess = false;
      }

      this.toggleRelatedFlags(variableRelationship)
      this.toggleRelatedFlags(secondVariableRelationship)

    },
    disappearedPersonCellphone: function(newVal, oldVal){
      var variableRelationship = {
        flagVar: 'showDisappearedPersonHasWhatsApp',
        relatedVar: '$store.state.record.socioec.disappearedPerson.hasWhatsApp',
        defaultValueRelatedVar: {}
      }

      if(newVal && newVal.length > 0){
        variableRelationship.conditionSuccess = true;
      }else{
        variableRelationship.conditionSuccess = false;
      }
      this.toggleRelatedFlags(variableRelationship)
    },
    disappearedPersonHasMedicalService: function(newVal, oldVal){
      // Setter at first is the index, must convert to object
      if(typeof newVal != "object"){
        newVal = this.directAnswers[newVal]
      }

      var variableRelationship = {
        flagVar: 'showDisappearedPersonMedicalServiceProvider',
        relatedVar: '$store.state.record.socioec.disappearedPerson.medicalService.provider',
        defaultValueRelatedVar: {}
      }
      var secondVariableRelationship = {
        flagVar: 'showDisappearedPersonMedicalServiceNumber',
        relatedVar: '$store.state.record.socioec.disappearedPerson.medicalService.number',
        defaultValueRelatedVar: ""
      }

      if(newVal && newVal.slug == 'yes'){
        variableRelationship.conditionSuccess = true;
        secondVariableRelationship.conditionSuccess = true;
      }else{
        variableRelationship.conditionSuccess = false;
        secondVariableRelationship.conditionSuccess = false;
      }
      this.toggleRelatedFlags(variableRelationship)
      this.toggleRelatedFlags(secondVariableRelationship)
    },
    disappearedPersonMedicalServiceProvider: function(newVal, oldVal){
      // Setter at first is the index, must convert to object
      if(typeof newVal != "object"){
        newVal = this.medicalServiceProviders[newVal]
      }

      var variableRelationship = {
        flagVar: 'showDisappearedPersonOtherMedicalService',
        relatedVar: '$store.state.record.socioec.disappearedPerson.medicalService.otherProvider',
        defaultValueRelatedVar: ""
      }

      if(newVal && newVal.slug == 'other'){
        variableRelationship.conditionSuccess = true;
      }else{
        variableRelationship.conditionSuccess = false;
      }
      this.toggleRelatedFlags(variableRelationship)
    },
    disappearedPersonHasLifeInsurance: function(newVal, oldVal){
      // Setter at first is the index, must convert to object
      if(typeof newVal != "object"){
        newVal = this.directAnswers[newVal]
      }

      var variableRelationship = {
        flagVar: 'showDisappearedPersonOtherLifeInsurance',
        relatedVar: '$store.state.record.socioec.disappearedPerson.credits.otherLifeInsurance',
        defaultValueRelatedVar: ""
      }

      if(newVal && newVal.slug == 'yes'){
        variableRelationship.conditionSuccess = true;
      }else{
        variableRelationship.conditionSuccess = false;
      }
      this.toggleRelatedFlags(variableRelationship)
    },
    disappearedPersonIsRegisteredCEAV: function(newVal, oldVal){
      // Setter at first is the index, must convert to object
      if(typeof newVal != "object"){
        newVal = this.directAnswers[newVal]
      }

      var variableRelationship = {
        flagVar: 'showDisappearedPersonWhichRegistry',
        relatedVar: '$store.state.record.socioec.disappearedPerson.condition.whichRegistry',
        defaultValueRelatedVar: {}
      }

      if(newVal && newVal.slug == 'yes'){
        variableRelationship.conditionSuccess = true;
      }else{
        variableRelationship.conditionSuccess = false;
      }
      this.toggleRelatedFlags(variableRelationship)
    },
    */
    /*
    : function(newVal, oldVal){
      // Setter at first is the index, must convert to object
      if(typeof newVal != "object"){
        newVal = this.XXCatalogXX[newVal]
      }

      var variableRelationship = {
        flagVar: '',
        relatedVar: '',
        defaultValueRelatedVar: ""
      }

      if(newVal && newVal.slug == 'XXConditionXX'){
        variableRelationship.conditionSuccess = true;
      }else{
        variableRelationship.conditionSuccess = false;
      }
      this.toggleRelatedFlags(variableRelationship)
    },
    */

  },
  computed: {
    userPermissions() {
      return this.$store.getters.user.permission;
    },
    record() {
      return this.$store.getters.record;
    },
    directAnswers() {
      return this.$store.state.directAnswers;
    },
    medicalServiceProviders(){
      return this.$store.state.medicalServiceProviders;
    },
    registryDate: {
      get() {
        return this.$store.state.record.socioec.disappearedPerson.registryDate;
      },
      set(value) {
        this.$store.state.record.socioec.disappearedPerson.registryDate = value;
      }
    },
    disappearedPersonStatus: {
    	get() {
        var storedValSlug = this.$store.state.record.socioec.disappearedPerson.status.slug;

        var variableRelationship = {
          flagVar: 'showDisappearedPersonPartnerName',
          relatedVar: '$store.state.record.socioec.disappearedPerson.partnerName',
          defaultValueRelatedVar: ''
        }

        var secondVariableRelationship = {
          flagVar: 'showDisappearedPersonPartnerName',
          relatedVar: '$store.state.record.socioec.disappearedPerson.partnerBirthday',
          defaultValueRelatedVar: null,
        }

        if(storedValSlug == 'married' || storedValSlug == 'concubine'){
          variableRelationship.conditionSuccess = true;
          secondVariableRelationship.conditionSuccess = true;
        }else{
          variableRelationship.conditionSuccess = false;
          secondVariableRelationship.conditionSuccess = false;
        }

        this.toggleRelatedFlags(variableRelationship)
        this.toggleRelatedFlags(secondVariableRelationship)

    		return this.personStatuses.findIndex(personStatuse => personStatuse.slug ==  this.$store.state.record.socioec.disappearedPerson.status.slug)
    	},
    	set(index) {
        this.$store.state.record.socioec.disappearedPerson.status = this.personStatuses[index];
    	}
    },
    disappearedPersonPartnerName: {
    	get() {
    		return this.$store.state.record.socioec.disappearedPerson.partnerName;
    	},
    	set(value) {
    		this.$store.state.record.socioec.disappearedPerson.partnerName = value;
    	}
    },
    disappearedPersonPartnerBirthday: {
      get() {
        return this.$store.state.record.socioec.disappearedPerson.partnerBirthday
      },
      set(value) {
        this.$store.state.record.socioec.disappearedPerson.partnerBirthday = value;
      }
    },
    disappearedPersonTelephone: {
    	get() {
    		return this.$store.state.record.socioec.disappearedPerson.telephone;
    	},
    	set(value) {
    		this.$store.state.record.socioec.disappearedPerson.telephone = value;
    	}
    },
    disappearedPersonCellphone: {
    	get() {
        var storedVal = this.$store.state.record.socioec.disappearedPerson.cellphone;

        var variableRelationship = {
          flagVar: 'showDisappearedPersonHasWhatsApp',
          relatedVar: '$store.state.record.socioec.disappearedPerson.hasWhatsApp',
          defaultValueRelatedVar: {}
        }

        if(storedVal.length > 0){
          variableRelationship.conditionSuccess = true;
        }else{
          variableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship)

    		return this.$store.state.record.socioec.disappearedPerson.cellphone;
    	},
    	set(value) {
    		this.$store.state.record.socioec.disappearedPerson.cellphone = value;
    	}
    },
    disappearedPersonHasWhatsApp: {
	    get() {
	    	return this.directAnswers.findIndex(directAnswer => directAnswer.slug == this.$store.state.record.socioec.disappearedPerson.hasWhatsApp.slug)
	    },
	    set(index) {
	    	this.$store.state.record.socioec.disappearedPerson.hasWhatsApp = this.directAnswers[index];
      },
    },
    disappearedPersonEmail: {
    	get() {
    		return this.$store.state.record.socioec.disappearedPerson.email;
    	},
    	set(value) {
    		this.$store.state.record.socioec.disappearedPerson.email = value;
    	}
    },
    disappearedPersonHasProperties: {
	    get() {
        var storedValSlug = this.$store.state.record.socioec.disappearedPerson.hasProperties.slug;

        var variableRelationship = {
          flagVar: 'showAddProperty',
          relatedVar: '$store.state.record.socioec.disappearedPerson.propertyList',
          defaultValueRelatedVar: []
        }

        if(storedValSlug == 'yes'){
          variableRelationship.conditionSuccess = true;
        }else {
          variableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship);

        return this.directAnswers.findIndex(directAnswer => directAnswer.slug == this.$store.state.record.socioec.disappearedPerson.hasProperties.slug)
	    },
	    set(index) {
	    	this.$store.state.record.socioec.disappearedPerson.hasProperties = this.directAnswers[index];
      },
    },
    propertyList:{
      get(){
        const storedVal = _.cloneDeep(this.$store.state.record.socioec.disappearedPerson.propertyList);
        var fakey = storedVal.map(property => {
          if(typeof property.propertyType == "object"){
            property.propertyType = this.livingPlaceKinds.findIndex(livingPlaceKind => livingPlaceKind.slug == property.propertyType.slug)
          }
          return property;
        })
        return fakey;
      },
      set(rawArray){
        // THIS CODE NEVER GETS CALLED INSTEAD "setterPropertyName" AND "setterPropertyType" ARE USED
      }
    },
    disappearedPersonHasMedicalService: {
	    get() {
        var storedValSlug = this.$store.state.record.socioec.disappearedPerson.medicalService.has.slug;

        var variableRelationship = {
          flagVar: 'showDisappearedPersonMedicalServiceProvider',
          relatedVar: '$store.state.record.socioec.disappearedPerson.medicalService.provider',
          defaultValueRelatedVar: {}
        }
        var secondVariableRelationship = {
          flagVar: 'showDisappearedPersonMedicalServiceNumber',
          relatedVar: '$store.state.record.socioec.disappearedPerson.medicalService.number',
          defaultValueRelatedVar: ""
        }

        if(storedValSlug == 'yes'){
          variableRelationship.conditionSuccess = true;
          secondVariableRelationship.conditionSuccess = true;
        }else{
          variableRelationship.conditionSuccess = false;
          secondVariableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship)
        this.toggleRelatedFlags(secondVariableRelationship)

	    	return this.directAnswers.findIndex(directAnswer => directAnswer.slug == this.$store.state.record.socioec.disappearedPerson.medicalService.has.slug)
	    },
	    set(index) {
	    	this.$store.state.record.socioec.disappearedPerson.medicalService.has = this.directAnswers[index];
      },
    },
    disappearedPersonMedicalServiceProvider: {
	    get() {
        var storedValSlug = this.$store.state.record.socioec.disappearedPerson.medicalService.provider.slug;

        var variableRelationship = {
          flagVar: 'showDisappearedPersonOtherMedicalService',
          relatedVar: '$store.state.record.socioec.disappearedPerson.medicalService.otherProvider',
          defaultValueRelatedVar: ""
        }

        if(storedValSlug == 'other'){
          variableRelationship.conditionSuccess = true;
        }else{
          variableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship)

	    	return this.medicalServiceProviders.findIndex(medicalServiceProvider => medicalServiceProvider.slug == this.$store.state.record.socioec.disappearedPerson.medicalService.provider.slug)
	    },
	    set(index) {
	    	this.$store.state.record.socioec.disappearedPerson.medicalService.provider = this.medicalServiceProviders[index];
      },
    },
    disappearedPersonOtherMedicalService: {
    	get() {
    		return this.$store.state.record.socioec.disappearedPerson.medicalService.otherProvider;
    	},
    	set(value) {
    		this.$store.state.record.socioec.disappearedPerson.medicalService.otherProvider = value;
    	}
    },
    disappearedPersonMedicalServiceNumber: {
    	get() {
    		return this.$store.state.record.socioec.disappearedPerson.medicalService.number;
    	},
    	set(value) {
    		this.$store.state.record.socioec.disappearedPerson.medicalService.number = value;
    	}
    },
    disappearedPersonHasCredit: {
      get(){
        var storedValSlug = this.$store.state.record.socioec.disappearedPerson.credits.hasCredit.slug;

        var variableRelationship = {
          flagVar: 'showAddCreditButton',
          relatedVar: '$store.state.record.socioec.disappearedPerson.credits.creditList',
          defaultValueRelatedVar: []
        }

        if(storedValSlug == 'yes'){
          variableRelationship.conditionSuccess = true;
        }else{
          variableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship);

        return this.directAnswers.findIndex(directAnswer => directAnswer.slug == this.$store.state.record.socioec.disappearedPerson.credits.hasCredit.slug)
      },
      set(index){
        this.$store.state.record.socioec.disappearedPerson.credits.hasCredit = this.directAnswers[index];
      },
    },
    creditList: {
      get(){
        const storedVal = _.cloneDeep(this.$store.state.record.socioec.disappearedPerson.credits.creditList);
        var fakey = storedVal.map(credit => {
          if(typeof credit.isJoint == "object"){
            credit.isJoint = this.directAnswers.findIndex(directAnswer => directAnswer.slug == credit.isJoint.slug)
          }
          return credit;
        })
        return fakey;
      },
      set(rawArray){
        // THIS CODE NEVER GETS CALLED INSTEAD "setterCreditType", "setterCoaccreditedName" AND "setterJointCredit" ARE USED

        /*
        THIS CODE NEVER GETS CALLED but leave while testing
        console.log("setter");
        rawArray.map(credit => {
          if(typeof credit.isJoint == "number"){
            credit.isJoint = this.directAnswer[credit.isJoint];
          }
          return credit;
        })
        this.$store.state.record.socioec.disappearedPerson.credits.creditList = rawArray;
        */
      }
    },
    disappearedPersonHasInsurance: {
	    get() {
        var storedValSlug = this.$store.state.record.socioec.disappearedPerson.credits.hasInsurance.slug;

        var variableRelationship = {
          flagVar: 'showAddInsurance',
          relatedVar: '$store.state.record.socioec.disappearedPerson.credits.insuranceList',
          defaultValueRelatedVar: []
        }

        if(storedValSlug == 'yes'){
          variableRelationship.conditionSuccess = true;
        }else{
          variableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship)

	    	return this.directAnswers.findIndex(directAnswer => directAnswer.slug == this.$store.state.record.socioec.disappearedPerson.credits.hasInsurance.slug)
	    },
	    set(index) {
	    	this.$store.state.record.socioec.disappearedPerson.credits.hasInsurance = this.directAnswers[index];
      },
    },
    insuranceList: {
    	get() {
        const storedVal = _.cloneDeep(this.$store.state.record.socioec.disappearedPerson.credits.insuranceList);
        var fakey = storedVal.map(insurance => {
          if(typeof insurance.insuranceType == "object"){
            insurance.insuranceType = this.insuranceTypes.findIndex(insuranceType => insuranceType.slug == insurance.insuranceType.slug)
          }
          return insurance;
        })
    		return fakey;
    	},
    	set(rawArray) {
    		// THIS CODE NEVER GETS CALLED INSTEAD "setterInsuranceName" AND "setterInsuranceType" ARE USED
    	}
    },
    disappearedPersonIsRegisteredCEAV: {
	    get() {
        var storedValSlug = this.$store.state.record.socioec.disappearedPerson.condition.isRegisteredCEAV.slug;

        var variableRelationship = {
          flagVar: 'showDisappearedPersonWhichRegistry',
          relatedVar: '$store.state.record.socioec.disappearedPerson.condition.whichRegistry',
          defaultValueRelatedVar: {}
        }

        if(storedValSlug == 'yes'){
          variableRelationship.conditionSuccess = true;
        }else{
          variableRelationship.conditionSuccess = false;
        }
        this.toggleRelatedFlags(variableRelationship)

	    	return this.directAnswers.findIndex(directAnswer => directAnswer.slug == this.$store.state.record.socioec.disappearedPerson.condition.isRegisteredCEAV.slug)
	    },
	    set(index) {
	    	this.$store.state.record.socioec.disappearedPerson.condition.isRegisteredCEAV = this.directAnswers[index];
      },
    },
    disappearedPersonWhichRegistry: {
	    get() {
	    	return this.missingRegistries.findIndex(missingRegistrie => missingRegistrie.slug == this.$store.state.record.socioec.disappearedPerson.condition.whichRegistry.slug)
	    },
	    set(index) {
	    	this.$store.state.record.socioec.disappearedPerson.condition.whichRegistry = this.missingRegistries[index];
      },
    },
    economicDependents(){
      return this.$store.state.record.socioec.economicDependents.length;
    }
  },
  methods: {
    handleError(phrase, error, notification) {
      console.log("Error while " + phrase, error);
      this.$store.commit("setShowNotification", {
        type: "error",
        title: "ERROR",
        text: notification
      });
      this.$store.commit("setIsLoadingState", false);
    },
    toggleRelatedFlags(params){
      let {flagVar, relatedVar, defaultValueRelatedVar, conditionSuccess} = params
      if(conditionSuccess){
        _.set(this, flagVar, true)
      }else{
        _.set(this, flagVar, false)

        const tmpRelatedVar = relatedVar.split('.')

        if(tmpRelatedVar[0] == '$store' && tmpRelatedVar[1] == 'state'){
          relatedVar = tmpRelatedVar.slice(2).join('.')
          _.set(this.$store.state, relatedVar, defaultValueRelatedVar)
        }else{
          _.set(this, relatedVar, defaultValueRelatedVar)
        }
      }
    },
    setterPropertyName(arrayIndex, newVal){
      // All this incredible maze is cause fricking Vue cannot detect the following changes to an array
      // https://vuejs.org/v2/guide/list.html#Caveats
      // So, every input (keystroke) is sended to the store, usually the computed prop handles the rewritting of the store
      // but as vue is incapable of registering that the array even changes
      // here we are to my displeasure
      this.$store.state.record.socioec.disappearedPerson.propertyList[arrayIndex].propertyName = newVal;
    },
    setterPropertyType(arrayIndex, answerIndex){
      // All this incredible maze is cause fricking Vue cannot detect the following changes to an array
      // https://vuejs.org/v2/guide/list.html#Caveats
      // So, radios send the index of the answer to the store, usually the computed prop handles the transformation from
      // such index to the actual object of the answer but as vue is incapable of registering that the array even changes
      // here we are to my displeasure
      this.$store.state.record.socioec.disappearedPerson.propertyList[arrayIndex].propertyType = this.livingPlaceKinds[answerIndex];
    },
    async addProperty(){
      this.$store.state.record.socioec.disappearedPerson.propertyList.push({propertyName:"", propertyType:{}})
    },
    setterCreditType(arrayIndex, newVal){
      // All this incredible maze is cause fricking Vue cannot detect the following changes to an array
      // https://vuejs.org/v2/guide/list.html#Caveats
      // So, every input (keystroke) is sended to the store, usually the computed prop handles the rewritting of the store
      // but as vue is incapable of registering that the array even changes
      // here we are to my displeasure
      this.$store.state.record.socioec.disappearedPerson.credits.creditList[arrayIndex].creditType = newVal;
    },
    setterJointCredit(arrayIndex, answerIndex){
      // All this incredible maze is cause fricking Vue cannot detect the following changes to an array
      // https://vuejs.org/v2/guide/list.html#Caveats
      // So, radios send the index of the answer to the store, usually the computed prop handles the transformation from
      // such index to the actual object of the answer but as vue is incapable of registering that the array even changes
      // here we are to my displeasure

      this.$store.state.record.socioec.disappearedPerson.credits.creditList[arrayIndex].isJoint = this.directAnswers[answerIndex];
      // if no, must erase coaccreditedName value
      if(this.directAnswers[answerIndex].slug == 'no'){
        //console.log("clear coaccreditedName at position " + arrayIndex);
        this.$store.state.record.socioec.disappearedPerson.credits.creditList[arrayIndex].coaccreditedName = "";
      }

      /*
      THIS CODE NEVER GETS CALLED but leave while testing
      this.$store.state.record.socioec.disappearedPerson.credits.creditList.map(credit => {
        if(typeof credit.isJoint == "number"){
          console.log('found');
          credit.isJoint = this.directAnswers[credit.isJoint];
        }
        return credit;
      })
      */
    },
    setterCoaccreditedName(arrayIndex, newVal){
      // All this incredible maze is cause fricking Vue cannot detect the following changes to an array
      // https://vuejs.org/v2/guide/list.html#Caveats
      // So, every input (keystroke) is sended to the store, usually the computed prop handles the rewritting of the store
      // but as vue is incapable of registering that the array even changes
      // here we are to my displeasure
      this.$store.state.record.socioec.disappearedPerson.credits.creditList[arrayIndex].coaccreditedName = newVal;
    },
    async addCredit(){
      this.$store.state.record.socioec.disappearedPerson.credits.creditList.push({creditType:"", isJoint:{}, coaccreditedName:""});
    },
    setterInsuranceName(arrayIndex, newVal){
      // All this incredible maze is cause fricking Vue cannot detect the following changes to an array
      // https://vuejs.org/v2/guide/list.html#Caveats
      // So, every input (keystroke) is sended to the store, usually the computed prop handles the rewritting of the store
      // but as vue is incapable of registering that the array even changes
      // here we are to my displeasure
      this.$store.state.record.socioec.disappearedPerson.credits.insuranceList[arrayIndex].insuranceName = newVal;
    },
    setterInsuranceType(arrayIndex, answerIndex){
      // All this incredible maze is cause fricking Vue cannot detect the following changes to an array
      // https://vuejs.org/v2/guide/list.html#Caveats
      // So, radios send the index of the answer to the store, usually the computed prop handles the transformation from
      // such index to the actual object of the answer but as vue is incapable of registering that the array even changes
      // here we are to my displeasure

      this.$store.state.record.socioec.disappearedPerson.credits.insuranceList[arrayIndex].insuranceType = this.insuranceTypes[answerIndex];
    },
    async addInsurance(){
      this.$store.state.record.socioec.disappearedPerson.credits.insuranceList.push({insuranceName:"", insuranceType:{}});
    },
    async addEconomicDependent(){
      let economicDependentJson = await axios.get(`${window.location.origin}/static/json/models/economicDependent.json`);
      let economicDependentModel = economicDependentJson.data;

      this.$store.state.record.socioec.economicDependents.push(economicDependentModel)
    },
    formatDate(value) {
      return value ? new Intl.DateTimeFormat("es").format(new Date(`${value}T00:00`)) : "";
    },
    async updateReport() {
      this.$store.commit("setIsLoadingState", true);

      try{
        const response = await this.$store.dispatch("updateReport");

        if(response.status == 403) {
          this.$router.replace("/login");
          this.$store.commit("setIsLoadingState", false);
          this.$store.commit("setShowNotification", {
            type: "error",
            title: "ERROR",
            text: response.message
          });
          return;
        }

        this.$store.commit("setShowNotification", {
          type: "success",
          title: "REGISTRO ACTUALIZADO CON ÉXITO"
        });

      } catch(error){
        console.log(error);
        this.$store.commit("setShowNotification", {
          type: "error",
          title: "ERROR",
          text: error
        });
      }

      await this.updateCsv();

      await this.$store.dispatch("initAllForms");
      this.$router.replace("/");
      this.$store.commit("setIsLoadingState", false)
    },
    async updateCsv(){
      this.$store.dispatch("updateCsv")
        .catch(error => {
          this.handleError("Error while updating csv: ", error, "Error al actualizar el csv");
        });
    }
  }
}
</script>

<style scoped lang="scss">
.add-dependent {
  box-shadow: none !important;
  border: 1px solid #000;
  width: 30px !important;
  height: 30px !important;
  background-color: transparent !important;
}

.add-text {
  margin: 0 1rem;
  font-weight: 800;
  color: #4361ee;
}
.light {
  font-weight: 300 !important;
}

</style>
